import * as React from 'react';
import { observer } from 'mobx-react-lite';
import { makeStyles, Box, Grid, Typography, Button } from '@material-ui/core';

const useStyles = makeStyles(theme => ({
	container: {
		margin: '1em 1em',
		background: 'white',
		[theme.breakpoints.down('sm')]: {
			margin: '1em 0em',
		},
	},
	filterButton: {
		height: '36px',
		marginRight: '5px',
		marginTop: '15px',
		color: '#007DBA',
		border: '1px solid #007DBA',
		'& .MuiButton-label': {
			marginTop: '1px',
		},
		'&:hover': {
			backgroundColor: '#007DBA',
			color: '#FFFFFF',
			border: '1px solid #007DBA',
		},
		'& .MuiButton-outlined': {
			border: '2px solid red',
		},
	},
}));

const NoItemSelected = observer(({ setReasonValue }: { setReasonValue: Function }) => {
	const classes = useStyles();

	const makeButton = (reason: string, text: string) => (
		<Button title={text} variant="outlined" className={classes.filterButton} onClick={() => setReasonValue(reason)}>
			{text}
		</Button>
	);

	return (
		<Box display="flex" justifyContent="Right" className={classes.container}>
			<Grid container>
				<Grid item xs={12}>
					<Typography variant="h6" component={'h1'}>
						No Sent Item Selected
					</Typography>
					<Typography variant="caption" color="textSecondary">
						Please select an item to see further details, or select from one of the filter options
					</Typography>
				</Grid>
				<Grid item xs={12}>
					{makeButton('all', 'Show all')}
					{makeButton('jobupdate', 'Job update')}
					{makeButton('jobapproval', 'Approval request')}
					{makeButton('feedback', 'Feedback')}
				</Grid>
			</Grid>
		</Box>
	);
});

export default NoItemSelected;
